import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateRange2 = ({ fromDate, setFromDate, toDate, setToDate }) => {
  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (toDate && date && toDate < date) {
      setToDate(null);
    }
  };
  return (
    <>
      <div className="date-range d-flex flex-column">
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2 ">
          From Date <span style={{ color: "red" }}>*</span>
        </label>
        <DatePicker
          selected={fromDate}
          onChange={handleFromDateChange}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select From Date"
          isClearable
          className="form-control"
        />
      </div>

      {/* To Date */}
      <div className="date-range d-flex flex-column">
        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-12 fs-xxl-14 mt-2">
          To Date <span style={{ color: "red" }}>*</span>
        </label>
        <DatePicker
          selected={toDate}
          onChange={(date) => setToDate(date)}
          dateFormat="dd/MM/yyyy"
          placeholderText="Select To Date"
          minDate={fromDate} // prevent selecting before fromDate
          isClearable
          className="form-control"
        />
      </div>
    </>
  );
};
export default DateRange2;
